import { Box, styled } from '@planne-software/uni/mui/material';

export const StepperRoot = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export const StepButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'disabledLook',
})<{ disabledLook: boolean }>(({ theme, disabledLook }) => {
  const c = theme.tokens.colors;
  const activeBorder = c['fill-color-primary-base']!;
  const disabledBorder = c['text-color-neutral-softer']!;
  return {
    appearance: 'none',
    background: c['color-neutral-white']!,
    border: `0.0625rem solid ${disabledLook ? disabledBorder : activeBorder}`,
    borderRadius: '0.5rem',
    padding: '0.5rem',
    width: '2rem',
    height: '2rem',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: disabledLook ? 'not-allowed' : 'pointer',
    color: disabledLook ? c['text-color-neutral-softer'] : c['fill-color-primary-base'],
    boxShadow: theme.tokens.shadow?.['shadow-xs'] ?? '0 0.0625rem 0.125rem rgba(16,24,40,0.05)',
    '&:focus-visible': {
      outline: `0.125rem solid ${activeBorder}`,
      outlineOffset: '0.0625rem',
    },
  };
});

export const NumberDisplay = styled(Box)(({ theme }) => ({
  ...theme.tokens.typography['text-xs-medium'],
  fontFamily: theme.typography.fontFamily,
  background: theme.tokens.colors['color-neutral-white']!,
  border: `0.0625rem solid ${theme.tokens.colors['text-color-neutral-strong']!}`,
  borderRadius: '0.5rem',
  padding: 0,
  width: '2rem',
  height: '2rem',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.tokens.colors['text-color-neutral-strongest'],
  textAlign: 'center',
}));
